export default __webpack_public_path__ + "static/media/batteryExchange.6cd501f1.png";